export default "__VITE_ASSET__CscoW1FM__"